var newsEvents = {





  loadEvents: function () {

    $('#event-date-filter').change(function () {
      $('#news-article-listing').empty()
      var url = $(this).attr('data-url').replace('#date', $(this).val()).replace('#val', $('#event-category-filter').val().toString());
      newsEvents._loadItems(url, $('#news-article-listing'), false)
    })
    $('#event-category-filter').change(function () {
      $('#news-article-listing').empty()
      var url = $(this).attr('data-url').replace('#val', $(this).val()).replace('#date', $('#event-date-filter').val().toString());
      newsEvents._loadItems(url, $('#news-article-listing'), false)

    })
    $('#event-upcoming-date-filter').change(function () {
      $('#news-events-listing').empty()
      var url = $(this).attr('data-url').replace('#val', $(this).val());
      newsEvents._loadItems(url, $('#news-events-listing'), true)

    })






    // $('.dynamic-events-items').each(function () {
    //   var markup="";  
    //   var url = $(this).attr('data-url')
    //   var $this = $(this);
    //   var isSlider = $(this).hasClass('dynamic-events-items--slider')
    //   var isUpcomingEvents  = $(this).hasClass('dynamic-events-items--upcoming')
    //   $.ajax({
    //     url: url, success: function (result) {
    //       var events = result.Events



    //       for (var index = 0; index < events.length; index++) {
    //        // const element = array[index];
    //       /// console.log(result[index])
    //     

    //       var EventBriefDescription = events[index].EventBriefDescription;
    //       var EventEndDate = events[index].EventEndDate;
    //       var EventLocation = events[index].EventLocation;
    //       var EventName = events[index].EventName;
    //       var EventRegisterLink = events[index].EventRegisterLink;
    //       var EventStartDate = events[index].EventStartDate;
    //       var EventThumbnailImage = events[index].EventThumbnailImage;
    //       var IsOnlineText = events[index].IsOnlineText;
    //       var VirtualEventText = events[index].VirtualEventText;
    //     

    //     

    //       markup += "\n<div class=\"".concat(isSlider ? 'swiper-slide' : 'col-12 col-md-6 col-lg-4', "\">\n<div class=\"generic-grid\">\n    ").concat(!isUpcomingEvents ? "\n    <div class=\"generic-grid__media\">\n    <img src=\"".concat(EventThumbnailImage, "\" alt=\"").concat(EventName, "\">\n    <span class=\"generic-grid__type ").concat(!VirtualEventText ? 'd-none' : '', "\">").concat(VirtualEventText, "</span>\n</div>\n    ") : '', "\n   \n    <h3 class=\"generic-grid__title\">\n       ").concat(EventName, "\n    </h3>\n\n    <div class=\"generic-grid__info\">\n        <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"16.79\"\n            viewBox=\"0 0 20 16.79\">\n            <g id=\"Group_165\" data-name=\"Group 165\"\n                transform=\"translate(-142.001 -844)\">\n                <path id=\"video003_-_E022\" data-name=\"video003 - E022\"\n                    d=\"M-9.825-43.062a.36.36,0,0,0-.321-.016l-2.359,1.043v-.607a1.619,1.619,0,0,0-1.683-1.548h-6.3a1.619,1.619,0,0,0-1.683,1.548v4.263a1.619,1.619,0,0,0,1.683,1.548h6.3a1.619,1.619,0,0,0,1.683-1.548v-.615l2.359,1.05a.3.3,0,0,0,.144.031.379.379,0,0,0,.178-.047.305.305,0,0,0,.152-.257v-4.59A.305.305,0,0,0-9.825-43.062Zm-3.34,4.684a.983.983,0,0,1-1.023.941h-6.3a.983.983,0,0,1-1.023-.941v-4.263a.983.983,0,0,1,1.023-.941h6.3a.983.983,0,0,1,1.023.941Zm2.833-.319-2.173-.965v-1.7l2.173-.965Z\"\n                    transform=\"translate(168.17 891.483)\" />\n                <path id=\"television001_-_E110\" data-name=\"television001 - E110\"\n                    d=\"M-8.89-50.28h-20v14.455h9.73v1.689h-3.479v.646h7.5v-.646H-18.62v-1.689h9.73ZM-28.35-36.471V-49.634H-9.43v13.164Z\"\n                    transform=\"translate(170.891 894.28)\" />\n            </g>\n        </svg>\n        ").concat(IsOnlineText, "\n\n    </div>\n\n    <div class=\"generic-grid__info\">\n                                                <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14.688\" height=\"22\"\n                                                    viewBox=\"0 0 14.688 22\">\n                                                    <path id=\"pin001_-_E017\" data-name=\"pin001 - E017\"\n                                                        d=\"M-6.456-50.67A7.345,7.345,0,0,0-13.8-43.326a7.492,7.492,0,0,0,.99,3.656l6.354,11,6.354-11a7.492,7.492,0,0,0,.99-3.656A7.345,7.345,0,0,0-6.456-50.67Zm0,.83A6.5,6.5,0,0,1,.058-43.326a6.577,6.577,0,0,1-.894,3.241l-5.62,9.755-5.62-9.755a6.577,6.577,0,0,1-.894-3.241A6.5,6.5,0,0,1-6.456-49.84Zm0,9.515a3.012,3.012,0,0,0,3.017-3,3.025,3.025,0,0,0-3.017-3.017,3,3,0,0,0-3,3.017A3,3,0,0,0-6.456-40.325Zm0-.83a2.174,2.174,0,0,1-2.171-2.171,2.177,2.177,0,0,1,2.171-2.187,2.18,2.18,0,0,1,2.187,2.187A2.187,2.187,0,0,1-6.456-41.155Z\"\n                                                        transform=\"translate(13.8 50.67)\" />\n                                                </svg>\n\n                                                ").concat(EventLocation, "\n\n                                            </div>\n    <div class=\"generic-grid__info\">\n        <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"17\" height=\"17\"\n            viewBox=\"0 0 17 17\">\n            <path id=\"clock001_-_E008\" data-name=\"clock001 - E008\"\n                d=\"M-10.28-31.78a8.575,8.575,0,0,1-3.3-.665,8.539,8.539,0,0,1-2.7-1.819,8.505,8.505,0,0,1-1.833-2.7,8.592,8.592,0,0,1-.665-3.313,8.513,8.513,0,0,1,8.5-8.5,8.525,8.525,0,0,1,3.3.665,8.539,8.539,0,0,1,2.7,1.819,8.659,8.659,0,0,1,1.833,2.7A8.694,8.694,0,0,1-1.78-40.28a8.592,8.592,0,0,1-.665,3.313,8.659,8.659,0,0,1-1.833,2.7,8.539,8.539,0,0,1-2.7,1.819A8.525,8.525,0,0,1-10.28-31.78Zm0-16.294a7.8,7.8,0,0,0-7.794,7.794,7.752,7.752,0,0,0,.611,3.042,7.834,7.834,0,0,0,1.684,2.471,7.645,7.645,0,0,0,2.471,1.67,7.734,7.734,0,0,0,3.028.611A7.794,7.794,0,0,0-2.486-40.28,7.734,7.734,0,0,0-3.1-43.308a7.926,7.926,0,0,0-1.67-2.485,8.085,8.085,0,0,0-2.485-1.67A7.686,7.686,0,0,0-10.28-48.074Zm.625,9.233h-4.752v-.706h4.046v-6.545h.706Z\"\n                transform=\"translate(18.78 48.78)\" />\n        </svg>\n        ").concat(EventStartDate, "\n    </div>\n\n\n\n    <p>").concat(EventBriefDescription, "</p>\n    <a href=\"").concat(EventRegisterLink, "\" class=\"btn btn-blue btn-less-radius\">Register now</a>\n    <a href=\"#\" class=\"btn btn-link btn-arrow-2 btn-blue-text\">Learn more</a>\n</div>\n\n\n\n\n</div>\n\n");

    //       } 
    //       // console.log(result);  

    //       // console.log(markup) 

    //       $this.append(markup);
    //       // newsEvents.initSwiper();


    //     } 
    //   });

    //   debugger  



    // })



  },

  _loadItems: function (url, parent, isUpcomingEvents) {
    var markup = '';

    $.ajax({
      url: url, success: function (result) {
        var events = result.Events || result.Articles


        console.log(events)


        for (var index = 0; index < events.length; index++) {
          // const element = array[index];
          /// console.log(result[index])
        

          var EventBriefDescription = events[index].EventBriefDescription || events[index].ArticleBriefDescription;
          var EventEndDate = new Date(events[index].EventEndDate);
          var EventLocation = events[index].EventLocation;
          var EventName = events[index].EventName || events[index].ArticleName;
          var EventRegisterLink = events[index].EventRegisterLink;
          var EventStartDate = new Date(events[index].EventStartDate || events[index].Date);
          var EventThumbnailImage = events[index].EventThumbnailImage || events[index].ArticleThumbnailImage;
          var IsOnlineText = events[index].IsOnlineText;
          var VirtualEventText = events[index].VirtualEventText;


          var options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };




          markup += "\n<div class=\"col-12 col-md-6 col-lg-4\">\n<div class=\"generic-grid\">\n    ".concat(!isUpcomingEvents ? "\n    <div class=\"generic-grid__media\">\n    <img src=\"".concat(EventThumbnailImage, "\" alt=\"").concat(EventName, "\">\n    <span class=\"generic-grid__type ").concat(!VirtualEventText ? 'd-none' : '', "\">").concat(VirtualEventText, "</span>\n</div>\n    ") : '', "\n   \n    <h3 class=\"generic-grid__title\">\n    <a href=\"").concat(EventRegisterLink, "\" >").concat(EventName, "</a>\n      \n    </h3>\n\n    <div class=\"generic-grid__info ").concat(!IsOnlineText ? 'd-none' : '', "\">\n        <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"16.79\"\n            viewBox=\"0 0 20 16.79\">\n            <g id=\"Group_165\" data-name=\"Group 165\"\n                transform=\"translate(-142.001 -844)\">\n                <path id=\"video003_-_E022\" data-name=\"video003 - E022\"\n                    d=\"M-9.825-43.062a.36.36,0,0,0-.321-.016l-2.359,1.043v-.607a1.619,1.619,0,0,0-1.683-1.548h-6.3a1.619,1.619,0,0,0-1.683,1.548v4.263a1.619,1.619,0,0,0,1.683,1.548h6.3a1.619,1.619,0,0,0,1.683-1.548v-.615l2.359,1.05a.3.3,0,0,0,.144.031.379.379,0,0,0,.178-.047.305.305,0,0,0,.152-.257v-4.59A.305.305,0,0,0-9.825-43.062Zm-3.34,4.684a.983.983,0,0,1-1.023.941h-6.3a.983.983,0,0,1-1.023-.941v-4.263a.983.983,0,0,1,1.023-.941h6.3a.983.983,0,0,1,1.023.941Zm2.833-.319-2.173-.965v-1.7l2.173-.965Z\"\n                    transform=\"translate(168.17 891.483)\" />\n                <path id=\"television001_-_E110\" data-name=\"television001 - E110\"\n                    d=\"M-8.89-50.28h-20v14.455h9.73v1.689h-3.479v.646h7.5v-.646H-18.62v-1.689h9.73ZM-28.35-36.471V-49.634H-9.43v13.164Z\"\n                    transform=\"translate(170.891 894.28)\" />\n            </g>\n        </svg>\n        ").concat(IsOnlineText, "\n\n    </div>\n\n    <div class=\"generic-grid__info  ").concat(!EventLocation ? 'd-none' : '', "\">\n                                                <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14.688\" height=\"22\"\n                                                    viewBox=\"0 0 14.688 22\">\n                                                    <path id=\"pin001_-_E017\" data-name=\"pin001 - E017\"\n                                                        d=\"M-6.456-50.67A7.345,7.345,0,0,0-13.8-43.326a7.492,7.492,0,0,0,.99,3.656l6.354,11,6.354-11a7.492,7.492,0,0,0,.99-3.656A7.345,7.345,0,0,0-6.456-50.67Zm0,.83A6.5,6.5,0,0,1,.058-43.326a6.577,6.577,0,0,1-.894,3.241l-5.62,9.755-5.62-9.755a6.577,6.577,0,0,1-.894-3.241A6.5,6.5,0,0,1-6.456-49.84Zm0,9.515a3.012,3.012,0,0,0,3.017-3,3.025,3.025,0,0,0-3.017-3.017,3,3,0,0,0-3,3.017A3,3,0,0,0-6.456-40.325Zm0-.83a2.174,2.174,0,0,1-2.171-2.171,2.177,2.177,0,0,1,2.171-2.187,2.18,2.18,0,0,1,2.187,2.187A2.187,2.187,0,0,1-6.456-41.155Z\"\n                                                        transform=\"translate(13.8 50.67)\" />\n                                                </svg>\n\n                                                ").concat(EventLocation, "\n\n                                            </div>\n    <div class=\"generic-grid__info  ").concat(!EventStartDate ? 'd-none' : '', "\">\n        <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"17\" height=\"17\"\n            viewBox=\"0 0 17 17\">\n            <path id=\"clock001_-_E008\" data-name=\"clock001 - E008\"\n                d=\"M-10.28-31.78a8.575,8.575,0,0,1-3.3-.665,8.539,8.539,0,0,1-2.7-1.819,8.505,8.505,0,0,1-1.833-2.7,8.592,8.592,0,0,1-.665-3.313,8.513,8.513,0,0,1,8.5-8.5,8.525,8.525,0,0,1,3.3.665,8.539,8.539,0,0,1,2.7,1.819,8.659,8.659,0,0,1,1.833,2.7A8.694,8.694,0,0,1-1.78-40.28a8.592,8.592,0,0,1-.665,3.313,8.659,8.659,0,0,1-1.833,2.7,8.539,8.539,0,0,1-2.7,1.819A8.525,8.525,0,0,1-10.28-31.78Zm0-16.294a7.8,7.8,0,0,0-7.794,7.794,7.752,7.752,0,0,0,.611,3.042,7.834,7.834,0,0,0,1.684,2.471,7.645,7.645,0,0,0,2.471,1.67,7.734,7.734,0,0,0,3.028.611A7.794,7.794,0,0,0-2.486-40.28,7.734,7.734,0,0,0-3.1-43.308a7.926,7.926,0,0,0-1.67-2.485,8.085,8.085,0,0,0-2.485-1.67A7.686,7.686,0,0,0-10.28-48.074Zm.625,9.233h-4.752v-.706h4.046v-6.545h.706Z\"\n                transform=\"translate(18.78 48.78)\" />\n        </svg>\n        ").concat(EventStartDate.toLocaleDateString('en', options), " / ").concat(EventStartDate.toLocaleTimeString('en', {
            hour: '2-digit',
            minute: '2-digit'
          }), "\n\n        ").concat(EventEndDate ? "\n        - ".concat(EventEndDate.toLocaleDateString('en', options), " / ").concat(EventEndDate.toLocaleTimeString('en', {
            hour: '2-digit',
            minute: '2-digit'
          }), "\n        ") : '', "\n    </div>\n\n\n\n    <p>").concat(EventBriefDescription, "</p>\n    ").concat(!isUpcomingEvents ? "\n    <a href=\"".concat(EventRegisterLink, "\" class=\"btn btn-blue btn-less-radius\">Register now</a>\n    <a href=\"#\" class=\"btn btn-link btn-arrow-2 btn-blue-text\">Learn more</a>\n    ") : '', "\n   \n</div>\n\n\n\n\n</div>\n\n");

        }
        // console.log(result);  

        // console.log(markup) 
        if(events.length === 0){
         $('#listing-empty-error').show()
        }
        else{
          $('#listing-empty-error').hide()
        }
        parent.append(markup);

        
        // newsEvents.initSwiper();


      }
    });
  },

  initSwiper: function () {
    console.log('swiper init avs 2')
    var swiper = new Swiper('.generic-slider', {
      slidesPerView: 3,
      watchOverflow: true,
      spaceBetween: 30,
      breakpoints: {
        // when window width is >= 320px

        // when window width is >= 480px
        480: {
          slidesPerView: 1.2,
          spaceBetween: 20
        },
        // when window width is >= 640px
        640: {
          slidesPerView: 1.5,
          spaceBetween: 20
        },
        937: {
          slidesPerView: 2,
          spaceBetween: 20
        }
      },
      navigation: {
        nextEl: ' .generic-slider ~ .swiper-button-next',
        prevEl: ' .generic-slider ~ .swiper-button-prev',
      },
      pagination: {
        el: '.generic-slider .swiper-pagination',
        type: 'bullets',
      },

    });

    var swiper2 = new Swiper('.events-gallery .swiper-container', {
      slidesPerView: 1,
      watchOverflow: true,
      spaceBetween: 0,

      navigation: {
        nextEl: ' .events-gallery .swiper-button-next',
        prevEl: ' .events-gallery .swiper-button-prev',
      },

      pagination: {
        el: '.events-gallery  .swiper-pagination',
        type: 'bullets',
      },

    });

  }



  // init: function () {

  //     this.initSwiper();
  // }
};
$(function () {
  newsEvents.initSwiper();
  newsEvents.loadEvents();


});